module.exports = "<p>\r\n  register works!\r\n</p>\r\n"